import { useFormContext, Controller } from 'react-hook-form';
import Spacing from 'components/Spacing';
import { TextField } from '@mui/material';
import { FieldRow } from 'components/FormElements';
import ShareClassSelection from './ShareClassSelection';
import { investee as Investee } from 'further-ui/validations';
import { useEffect } from 'react';

const ShareClassDetailsForm: React.FC = () => {
  const { control, watch, setValue } = useFormContext<
    | (Investee.NewCompanyFormValues & { storedShareClassId?: string })
    | (Investee.NewShareClassFormValues & { storedShareClassId?: string })
  >();

  const values = watch();

  useEffect(() => {
    if (!values.isNewShareClass && values.storedShareClassId) {
      setValue('shareClassId', values.storedShareClassId);
    }
  }, [values.isNewShareClass]);

  if (!values.firmId) {
    return null;
  }

  return (
    <>
      <Spacing>
        <ShareClassSelection
          isNewShareClass={values.isNewShareClass ?? false}
          control={control}
          resetShareClassDropdown={() => {
            setValue('shareClassId', '');
            if (values.shareClassId) {
              setValue('storedShareClassId', values.shareClassId);
            }
          }}
          onShareClassChange={(shareClass) => {
            setValue('shareClassId', shareClass);
          }}
          investeeId={values.investeeId ?? ''}
        />

        {values.isNewShareClass && (
          <>
            <FieldRow title="Share class*" centerTitle>
              <Controller
                name="shareClass"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    placeholder="Enter share class. e.g. Ordinary"
                    required
                    fullWidth
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </FieldRow>
            <FieldRow title="Nominal share value" centerTitle>
              <Controller
                name="nominalShareValue"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    placeholder="Enter nominal share value"
                    fullWidth
                    error={!!error}
                    helperText={error?.message}
                  />
                )}
              />
            </FieldRow>
          </>
        )}
      </Spacing>
    </>
  );
};

export default ShareClassDetailsForm;
